import script from "./ChristmasFX.vue?vue&type=script&setup=true&lang=js"
export * from "./ChristmasFX.vue?vue&type=script&setup=true&lang=js"

import "./ChristmasFX.vue?vue&type=style&index=0&id=efe08c58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efe08c58"]])

export default __exports__